import React from 'react';
import { connect } from 'react-redux';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Button from 'shared/components/button/Button';
import Loader from 'features/Loader/Loader';
import SeriesDetailsOverview from './SeriesDetailsOverview';
import ExerciesBlock from './Exercies/ExerciesBlock';
import {
  getSeriesById,
  getWorkoutWithioutSubs,
  deleteSeries
} from '../../ducks/workoutActions';

class SeriesDetails extends React.Component {
  constructor(props){
    super(props);
    this.workoutId = props.match.params.workoutId;
    this.seriesId = props.match.params.id;
  }

  componentDidMount(){
    let { history } = this.props;
    this.props.getSeriesById(this.workoutId, this.seriesId, history);
    this.props.getWorkout(this.workoutId, history);
  }

  render() {
    let {
      currentSeries,
      workout,
      deleteSeries,
      history,
      loadingWorkout,
      seriesLoading
    } = this.props;

    if(loadingWorkout || seriesLoading) {
      return(<Loader/>);
    }
    return (
      <div className="workout series-details">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="/workouts">Workouts</Breadcrumb.Item>
            <Breadcrumb.Item href={`/workouts/${this.workoutId}`}>
              {workout && workout.name}
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{currentSeries && currentSeries.name}</Breadcrumb.Item>
          </Breadcrumb>

          <div className="page-title">
            <h4>Series</h4>
            <div className="title-action">
              <div className="icon-link">
                <i
                  className="fas fa-trash"
                  onClick={e => {
                    deleteSeries(this.workoutId, this.seriesId, history)
                  }}
                ></i>
              </div>
              <Button
                color="primary"
                label="Edit"
                onClick={event => history.push(`/workouts/${this.workoutId}/series/${this.seriesId}/edit`)}
              />
            </div>
          </div>

          <SeriesDetailsOverview series={currentSeries}/>

          <div className="exercies-list">
            {currentSeries &&
              currentSeries.exerciseCollection &&
              currentSeries.exerciseCollection.map((exercise, index) => {
              return(
                <ExerciesBlock
                  key={exercise.id}
                  exercise={exercise}
                  index={index}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentSeries: state.workoutReducer.currentSeries,
    workout: state.workoutReducer.workout,
    loadingWorkout: state.workoutReducer.loading,
    seriesLoading: state.workoutReducer.seriesLoading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSeriesById: (workoutId, seriesId, history) => dispatch(getSeriesById(workoutId, seriesId, history)),
    getWorkout: (workoutId, history) => dispatch(getWorkoutWithioutSubs(workoutId, history)),
    deleteSeries: (workoutId, seriesId, history) => dispatch(deleteSeries(workoutId, seriesId, history))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SeriesDetails);
